import { keywordGroups } from '@/mocks/home';
import Reveal from '@/components/feature/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function KeywordIndex() {
  return (
    <section id="keywords" className="border-b border-background-200 bg-secondary-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="04"
            eyebrow="Keyword Index"
            title="关键词索引：直接跳到你想看的那一类"
            desc="像查工具书一样使用本站。下面把高频检索词、内容形态与时间维度分组列出，覆盖黑料反差深扒过程中最常被查找的入口。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-10">
          {keywordGroups.map((group, index) => (
            <Reveal key={group.group} delay={index * 110}>
              <div className="h-full rounded-lg border border-background-200 bg-background-50 p-6">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{group.title}</h3>
                  <span className="font-label text-[10px] uppercase tracking-[0.2em] text-foreground-400">
                    {group.group}
                  </span>
                </div>
                <div className="mt-5 flex flex-wrap gap-2">
                  {group.words.map((word) => (
                    <a
                      key={word}
                      href="#timeline"
                      className="rounded-md border border-background-200 bg-background-100 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                    >
                      {word}
                    </a>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}